import { AgentItem } from 'components/queue-view/live-workload-tab/models/agent-item';
import { OperatorStatus } from 'components/queue-view/live-workload-tab/models/operator-status';
import { Sort, SortDirection } from 'components/queue-view/live-workload-tab/models/sort';

export class AgentListSortingHelper {
  // Agent list can be sorted by Agent name or by the availability of one of the services (Chat/SMS/Facebook/Async message/Email).
  // We can sort Agent names in asc or desc order.
  // Sorting by one of the services is more complex:
  // agent list is sorted by agents' availability first, then by custom statuses (always alphabetically ASC), then by bestName (always alphabetically ASC).
  // In that case sort direction change affects only the sorting of availability, it doesn't change neither the order of custom statuses nor bestNames.

  public static sort(data: AgentItem[], activeSort: Sort): AgentItem[] {
    return data.sort((originalItem1, originalItem2) => {
      // We need these variables because sort direction change has effects only on bestName sorting and on statusTypes comparison,
      // but in other cases we have to keep the ASC sorting order

      const flip = activeSort.direction === SortDirection.DESC;
      let item1 = flip ? originalItem2 : originalItem1;
      let item2 = flip ? originalItem1 : originalItem2;

      if (activeSort.active === 'bestName') {
        // compares based on sorting direction
        return this._compareBestNames(item1, item2);
      }
      const statusCompare = this._compareStatusTypes(item1, item2, activeSort);

      if (statusCompare === 0) {
        const customStatusCompare = this._compareCustomStatuses(originalItem1, originalItem2, activeSort);
        if (customStatusCompare === 0) {
          return this._compareBestNames(originalItem1, originalItem2);
        }
        return customStatusCompare;
      } else {
        return statusCompare;
      }
    });
  }

  private static _compareCustomStatuses(a: AgentItem, b: AgentItem, activeSort: Sort): number {
    const customStatusNameA = a.services[activeSort.active].customStatusName;
    const customStatusNameB = b.services[activeSort.active].customStatusName;

    if (!customStatusNameA && !customStatusNameB) {
      return 0;
    }
    if (customStatusNameA && !customStatusNameB) {
      return -1;
    }
    if (!customStatusNameA && customStatusNameB) {
      return 1;
    }
    return customStatusNameA.toLowerCase().localeCompare(customStatusNameB.toLowerCase());
  }

  private static _compareBestNames(a: AgentItem, b: AgentItem): number {
    return a.bestName.toLowerCase().localeCompare(b.bestName.toLowerCase());
  }

  private static _compareStatusTypes(a: AgentItem, b: AgentItem, activeSort: Sort): number {
    if (a.services[activeSort.active] && b.services[activeSort.active]) {
      const statusTypeA = a.services[activeSort.active].statusType;
      const statusTypeB = b.services[activeSort.active].statusType;

      if (statusTypeA === OperatorStatus.AVAILABLE && statusTypeB === OperatorStatus.AWAY) {
        return -1;
      }
      if (statusTypeA === OperatorStatus.AWAY && statusTypeB === OperatorStatus.AVAILABLE) {
        return 1;
      }
      return 0;
    }
  }
}
